import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';

export default function AchievementCard({ achievement }) {
  const getBadgeIcon = (type) => {
    if (!type) return '🏆';
    switch (type) {
      case 'streak': return '🔥';
      case 'first-time': return '⭐';
      case 'count': return '📊';
      default: return '🏆';
    }
  };

  return (
    <div className="bg-white rounded-xl border-2 border-border p-4 text-center hover:border-primary hover:shadow-lg transition-all">
      <div className="text-4xl mb-2">
        {getBadgeIcon(achievement.type)}
      </div>
      <h3 className="text-sm font-bold text-text-primary mb-1 line-clamp-2">
        {achievement.title}
      </h3>
      {achievement.completedDate && (
        <p className="text-xs text-text-secondary">
          {achievement.completedDate?.toDate 
            ? format(achievement.completedDate.toDate(), 'MMM yyyy')
            : ''}
        </p>
      )}
    </div>
  );
}
